export enum Roles {
  'VISITOR' = 'visitor',
  'MEMBER' = 'member',
  'ARTIST' = 'artist',
  'COLLECTOR' = 'collector',
  'GALLERY' = 'gallery',
  'CURATOR' = 'curator'
}
